import { useContext, useState, useEffect, useCallback } from 'react';
import { HimmaContext } from '../Context/HimmaContext';

export const useConfigurationSettings = () => {
  const api = useContext(HimmaContext)!;
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSettings = useCallback(async (language?: string) => {
    setLoading(true);
    setError(null);
    try {
      console.log(language)
      const response = await api.getConfigurationSettings();
      setData(response.data);
      return response.data;
    } catch (err) {
      let errorMessage = 'Failed to fetch configuration settings';

      if (err && typeof err === 'object' && 'response' in err) {
        const axiosError = err as { response?: { data?: { message?: string } }; message?: string };
        if (axiosError.response?.data?.message) {
          errorMessage = axiosError.response.data.message;
        } else if (axiosError.message) {
          errorMessage = axiosError.message;
        }
      }

      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return {
    data,
    loading,
    error,
    refetch: fetchSettings,
  };
};
